import { render } from "./ListLavadosCaja.vue?vue&type=template&id=bd2eea1c"
import script from "./ListLavadosCaja.vue?vue&type=script&lang=js"
export * from "./ListLavadosCaja.vue?vue&type=script&lang=js"

import exportComponent from "C:\\repos\\excurix\\src\\UI\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__